import { Component, Input, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterLink, RouterLinkActive, RouterModule, RouterOutlet } from '@angular/router';

import { MatSidenavModule } from '@angular/material/sidenav';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { OAuthService } from 'angular-oauth2-oidc';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Component({
    selector: 'app-iniciar',
    standalone: true,
    imports: [
        CommonModule,
        NgOptimizedImage,
        RouterLink,
        RouterOutlet,
        RouterModule,
        RouterLinkActive,
        MatSidenavModule,
    ],
    templateUrl: './iniciar.component.html',
    styleUrl: './iniciar.component.scss',
})
export class IniciarComponent implements OnInit {
    currentUrl: string = "";
    isMobile = false;

    constructor(private router: Router,private bpObserver: BreakpointObserver, private oauthService: OAuthService) {
        this.bpObserver.observe(['(max-width: 740px)'])
        .subscribe(result => {
          this.isMobile = result.matches;
        });
        let login = localStorage.getItem('login');
        if (login != null && login != undefined)
            this.router.navigate(['/dashboard']);
    }

    ngOnInit() {
        localStorage.setItem('deslogar', "false");
    }

    IsTelaInicial() {
        if (this.currentUrl == "inicial") {
            return true;
        }
        return false;
    }
}
